import React, { useState } from 'react';
import CarForm from './CarForm';
import { PROCEDURE_TYPE } from '../../../../configs';
import { RegistryNumberInput } from '../RegistryNumberInput';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import VehiclesDTO from '../../../../dto/VehiclesDTO';
import SearchInformationBlock from '../SearchInformationBlock';

export default function ApplicationVehicleForm(props) {
  const {
    formMeta, control, selectedProcedure, numberHelperAction = _ => {
    }, procedure, labelPrefix, prefix, getValues = () => {}, setValue = () => {}, getFieldState = () => {}, applicantType, federal_law_number,
  } = props;

  const [isHidden, setIsHidden] = useState(false);

  const DTO = new VehiclesDTO();
  const attributes = DTO.getAttributesByName();
  return (
    <>
      {/*
        {![PROCEDURE_TYPE.PROCEDURE_1227_7, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1227_9].includes(selectedProcedure) ? (
          <>
            <div className="f4">Информация по ОСАГО владельца ТС</div>
            <InsuranceForm control={control} formMeta={formMeta} prefix="insurance." disabled={disabled} />
            <div className="mb-3" />
          </>
        ) : null}
      */}
      {![PROCEDURE_TYPE.PROCEDURE_1227_6].includes(selectedProcedure) ? (
        <>
          <Row className="row-cols-1">
            <RegistryNumberInput
              formMeta={formMeta}
              numberHelperAction={numberHelperAction}
              labelPrefix={labelPrefix}
              /* setIsHidden={[PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_kt_exlt].includes(selectedProcedure) ? setIsHidden : () => {}} */
              setValue={setValue}
              getValues={getValues}
              getFieldState={getFieldState}
              procedure={procedure}
              control={control}
              title="Номер записи в реестре ЛТ"
              prefix={prefix}
              isMultipleSelect
            />
          </Row>
          {/* <Row className="row-cols-2"> */}
          {/*  <FieldDTOWithCol */}
          {/*    control={control} */}
          {/*    formMeta={formMeta} */}
          {/*    type="text" */}
          {/*    component={DateTimePicker} */}
          {/*    hideTime */}
          {/*    changeFormat="YYYY-MM-DD" */}
          {/*    dtoObject={attributes.effective_date} */}
          {/*    disabled */}
          {/*    variant="material" */}
          {/*    withLabel */}
          {/*    namePrefix={prefix} */}
          {/*  /> */}
          {/*  <FieldDTOWithCol */}
          {/*    control={control} */}
          {/*    formMeta={formMeta} */}
          {/*    type="text" */}
          {/*    component={DateTimePicker} */}
          {/*    hideTime */}
          {/*    disabled */}
          {/*    changeFormat="YYYY-MM-DD" */}
          {/*    dtoObject={attributes.expiration_date} */}
          {/*    variant="material" */}
          {/*    withLabel */}
          {/*    namePrefix={prefix} */}
          {/*  /> */}
          {/* </Row> */}
          <div className="mb-3" />
        </>
      ) : null }
      {!isHidden && [PROCEDURE_TYPE.PROCEDURE_1227_6, PROCEDURE_TYPE.PROCEDURE_kt_exlt].includes(selectedProcedure) ? (
        <>
          <div className="f4">Информация о транспортном средстве</div>
          <SearchInformationBlock getValues={getValues} setValue={setValue} prefix={prefix} procedure={procedure} types={['vehicle_vin', 'vehicle_lpn']} />
          <CarForm {...props} selectedProcedure={selectedProcedure} federal_law_number={federal_law_number} applicantType={applicantType} disabled={isHidden} />
          <div className="mb-3" />
        </>
      ) : null}
    </>
  );
}
